module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/login/es.json
// module id = wFL9
// module chunks = 1